<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  ref="mySwiper">
            <swiper-slide v-for="(item, index) in homeRotation"
                          :key="index">
              <img :src="item.resUrl"
                   style=" cursor: pointer;"
                   width="930"
                   height="380"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright display_column display_between">
          <!-- <img src="/image/index/topshuiyi.png" />
                    <img src="/image/index/topshuiyi2.png" /> -->
          <img v-for="(item, index) in topRotation"
               :key="index + '1'"
               :src="item.resUrl"
               @click="Towindowurl(item.url)"
               width="296"
               height="183"
               style="border-radius:10px; cursor: pointer;" />
          <img v-for="(item, index) in botRotation"
               :key="index + '2'"
               :src="item.resUrl"
               @click="Towindowurl(item.url)"
               width="296"
               height="183"
               style="border-radius:10px; cursor: pointer;box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);" />
        </div>
      </div>
    </div>
    <div class="main EC_width">
      <div class="gl_title_bar">
        <div class="gl_tb_left">
          <span class="tagTitle"
                :class="{ tagTitleActive: tagIndex == item.id }"
                v-for="(item, index) in meetingtype"
                :key="index"
                @click="tag(item.id)">
            {{ item.valueText }}
          </span>
        </div>
        <div class="gl_tb_right">
          <!-- <a href="javascript:;" class="gl_tb_right_more">
                        <img src="/image/index/moreimg.png" class="gltb_moreimg" />
                        更多
                    </a> -->
        </div>
      </div>
      <div class="positionBtn EC_width marginBottom40"
           v-if="meetinglist.startlist.length > 0 || meetinglist.endlist.length > 0">
        <swiper :options="swiperOption2"
                ref="mySwiper">
          <swiper-slide v-for="(startlistitem, index) in meetingliststartlist"
                        :key="index + '2'">
            <router-link class="mediaImg"
                         target="_blank"
                         :to="{ name: 'meetingpc', query: { mid: startlistitem.id } }">
              <img :src="startlistitem.mtg_Image_ResUrl"
                   width="285"
                   height="169" />
              <div style="margin-top: 10px;float:left">
                <span class="sign ">
                  报名中
                </span>
                {{ startlistitem.mtg_Name }}
              </div>
            </router-link>
          </swiper-slide>
          <swiper-slide v-for="(endlistitem, index) in meetinglistendlist"
                        :key="index + '3'">
            <router-link class="mediaImg"
                         target="_blank"
                         :to="{ name: 'meetingpc', query: { mid: endlistitem.id } }">
              <img :src="endlistitem.mtg_Image_ResUrl"
                   width="285"
                   height="169" />
              <div style="margin-top: 10px">
                <span class="sign signDis">
                  已结束
                </span>
                <span> {{ ellipsis(endlistitem.mtg_Name, 30) }}</span>
              </div>
            </router-link>
          </swiper-slide>
        </swiper>

        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
      <div v-else
           class="positionBtn EC_width"
           style=" height: 90px; text-align: center; margin-top: 50px; font-size: 30px; color: #C4C4C4; ">
        暂无会议
      </div>
      <div class="marginTop50 marginBottom50"
           v-for="(item, index) in centreRotation"
           :key="index"
           @click="Towindowurl(item.url)">
        <img :src="item.resUrl"
             style="width:1240px" />
      </div>
      <div class="display_between_nocenter">
        <div class="mainLeft">
          <div class="gl_title_bar">
            <div class="gl_tb_left">
              <span class="normaltitle">精品课件</span>
            </div>
          </div>
          <div class="tipsBanner marginTop20 display_column">
            <div class="flex1"></div>
            <div class="tips activeLine"
                 v-for="(item, index) in courseList.slice(0, 1)"
                 :key="index"
                 @click="courseclick(item)">
              {{ item.title }}
            </div>
          </div>
          <div :style="index == 0 ? 'border:none;marginTop:0' : ''"
               class="border_top_18 marginTop20"
               v-for="(item, index) in courseList.slice(1, 4)"
               :key="index"
               @click="courseclick(item)">
            <div class="gl_title_vertical_line gl_title_v_line_active_gree activeLine">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="mainCenter flex1">
          <div>
            <div class="gl_title_bar marginBottom20">
              <div class="gl_tb_left">
                <span class="normaltitle">学术动态</span>
              </div>
              <div class="gl_tb_right">
                <a href="javascript:;"
                   class="gl_tb_right_more"
                   @click="onMore(201, '学术动态')">
                  <img src="/image/index/moreimg.png"
                       class="gltb_moreimg" />
                  更多
                </a>
              </div>
            </div>
            <div class="gl_listWrapBar_nopad controlShow"
                 v-for="(item, index) in academicList"
                 :key="index">
              <div class="gl_imgList setShow"
                   @click="clkNews(item, '学术动态')">
                <img :src="item.slideShow"
                     width="156px"
                     height="88px;" />
              </div>
              <a href="javascript:;"
                 class="gl_listItem display_column_between">
                <div class="gl_listItemTitle  fontBold setShow"
                     style="margin-bottom: 9px;"
                     @click="clkNews(item, '学术动态')">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle disShow"
                     style="margin-bottom: 8.8px;"
                     @click="clkNews(item, '学术动态')">
                  {{ ellipsis(item.title, 38) }}
                </div>
                <div class="display_between marginTop10 setShow">
                  <div></div>
                  <div class="gl_inforshow">
                    <span class="marginRight20"> {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
                    <span>
                      <img src="/image/index/chakan.png" />
                      {{ item.clickVolume }}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div>
            <div class="gl_title_bar marginBottom30">
              <div class="gl_tb_left">
                <span class="normaltitle">精彩讲座</span>
              </div>
              <div class="gl_tb_right">
                <a href="javascript:;"
                   class="gl_tb_right_more"
                   @click="onMore(202, '精彩讲座')">
                  <img src="/image/index/moreimg.png"
                       class="gltb_moreimg" />
                  更多
                </a>
              </div>
            </div>
            <div class="display_between">
              <div class="flex1 activelecture"
                   v-for="(item, index) in lectureList"
                   :key="index"
                   @click="clkNews(item, '精彩讲座')">
                <img :src="item.slideShow"
                     width="290px"
                     height="169px;" />
                <p class="marginTop10 titlesytle">{{ ellipsis(item.title, 15) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mainRight">
          <div>
            <div class="gl_title_bar marginBottom20">
              <div class="gl_tb_left">
                <span class="normaltitle">会议直播</span>
              </div>
              <div class="gl_tb_right">
                <a href="javascript:;"
                   class="gl_tb_right_more"
                   @click="onMore(204, '会议直播')">
                  <img src="/image/index/moreimg.png"
                       class="gltb_moreimg" />
                  更多
                </a>
              </div>
            </div>
            <div class="video_block marginTop20"
                 v-for="(item, index) in meetdirectList"
                 :key="index"
                 @click="clkNews(item, '会议直播')">
              <img :src="item.slideShow"
                   width="300px"
                   height="150px;" />
              <div class="video_title titlesytlezhibo">
                {{ item.title }}
              </div>
            </div>
          </div>
          <div>
            <div class="gl_title_bar marginBottom10">
              <div class="gl_tb_left">
                <span class="normaltitle">全国全科会议及培训</span>
              </div>
            </div>
            <div class="scrollSet"
                 ref="time">
              <div class="marginBottom10 timelistbox"
                   v-for="(item, index) in trainmeetinglist"
                   :key="index"
                   @mouseenter="changeTimeSrc(index, '/image/icon/time1.png')"
                   @mouseleave="changeTimeSrc(index, '/image/icon/time2.png')">
                <div class="timeleft">
                  <img src="/image/icon/time2.png"
                       alt="" />
                </div>
                <router-link class="mediaImg activeLine meetinglist"
                             target="_blank"
                             :to="{ name: 'meetingpc', query: { mid: item.id } }">
                  <!-- <p>{{ formatTime(item.mtg_StartTime, 'YYYY/MM/DD') }}-{{ formatTime(item.mtg_EndTime, 'YYYY/MM/DD') }}</p> -->
                  <p>{{ formatTime(item.mtg_StartTime, 'YYYY/MM/DD') }}</p>
                  <p>{{ ellipsis(item.mtg_Name, 15) }}</p>
                </router-link>
              </div>
              <div class="timexian"
                   :style="'height:' + trainmeetinglist.length * 53 + 'px'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
export default {
  name: 'meeting',
  data () {
    return {
      tagIndex: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive'
        }
      },
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled'
        }
      },
      apiData: {},
      meetingtype: [],
      meetinglist: {
        endlist: [],
        startlist: []
      },
      homeRotation: null, //轮播
      topRotation: null, //右上
      botRotation: null, //右下
      centreRotation: null, //中
      courseList: [], //课程列表
      academicList: [], //学术动态
      lectureList: [], //精彩讲座
      trainmeetinglist: [], //全国全科会议及培训
      meetdirectList: [],
      meetingliststartlist: [],
      meetinglistendlist: []
    };
  },
  created () {
    this.getData();
    this.GetRotationInfo();
    this.getMeetingType();
    //获取精彩课程
    this.GetCourseVideoList();
    //获取学术动态,精彩讲座
    this.GetGpSiteNewInfoPageList();
    //全国全科会议及培训
    this.getTrainMeetingList();
  },
  methods: {
    tag (index) {
      this.tagIndex = index;
      this.getMeetingListBytypeid();
    },
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.meeting;
        });
    },
    /**获取会议类型 */
    getMeetingType () {
      this.httphelper.get('/api/BasicsmesApi/GetCodeResultList?type=4').then(res => {
        if (res.code == 200) {
          this.meetingtype = res.data;
          this.tagIndex = res.data[0].id;
          this.getMeetingListBytypeid();
        }
      });
    },
    /** 根据会议类型获取会议列表 */
    getMeetingListBytypeid () {
      this.httphelper
        .post('/api/MeetingApi/GetMeetingList', {
          mtgType: this.tagIndex
        })
        .then(res => {
          if (res.data.code == 200) {
            this.meetinglistendlist = [];
            this.meetingliststartlist = [];
            this.meetinglist = res.data.data;
            if (res.data.data.startlist.length > 0) {
              this.meetingliststartlist = res.data.data.startlist.sort(function (a, b) {
                return new Date(a.mtg_StartTime).valueOf() - new Date(b.mtg_StartTime).valueOf();
              });
            }
            if (res.data.data.endlist.length > 0) {
              this.meetinglistendlist = res.data.data.endlist.sort(function (a, b) {
                return new Date(b.mtg_StartTime).valueOf() - new Date(a.mtg_StartTime).valueOf();
              });
            }
          }
        });
    },
    /** 获取轮播数据*/
    GetRotationInfo () {
      let _this = this;
      let arr = [20, 21, 22, 23]; //分别代表首页轮播，首页右上，首页右下，首页中部，首页下部
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 20) {
                _this.homeRotation = res.data.data || null;
              }
              if (arr[i] == 21) {
                _this.topRotation = res.data.data || null;
              }
              if (arr[i] == 22) {
                _this.botRotation = res.data.data || null;
              }
              if (arr[i] == 23) {
                _this.centreRotation = res.data.data || null;
              }
            }
          });
      }
    },
    /** 轮播、广告图跳转外链
    轮播、广告图跳转外链 */
    Towindowurl (url) {
      let urlstr = url;
      let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
      if (urlstr.search('grasshealList/grasshealListdetail') > -1) {
        const { href } = this.$router.resolve({
          path: '/home/inforDetails?' + param
        });
        window.open(href, '_blank');
      } else if (url != null && url != '') {
        window.open(url);
      }
    },
    GetCourseVideoList () {
      let _this = this;
      this.httphelper
        .post('/api/CGPInfoApi/GetGpCourseVideoInfoPageLists', {
          course_Type: 0,
          fuzzysearch: '',
          labelgather: '',
          orderBy: 1,
          pageIndex: 1,
          pageSize: 4,
          resinfoType: 4
        })
        .then(res => {
          // _this.courseList = res.data.data.gpCourseVideoInfoViews.slice(0, 1)
          _this.courseList = res.data.data.gpCourseVideoInfoViews;
        });
    },
    /** 课程跳转*/
    courseclick (item) {
      let id = item.id;
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    },
    /** 时间转换 */
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /* 获取学术动态,精彩讲座 */
    GetGpSiteNewInfoPageList () {
      let _this = this;
      let arrcolumn = [201, 202, 204];
      let pagesize = 4;
      for (let i = 0; i < arrcolumn.length; i++) {
        if (arrcolumn[i] == 201) {
          pagesize = 5;
        } else if (arrcolumn[i] == 202) {
          pagesize = 2;
        } else if (arrcolumn[i] == 204) {
          pagesize = 1;
        }

        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arrcolumn[i],
            pageIndex: 0,
            pageSize: pagesize
          })
          .then(res => {
            if (res.data.code == 200) {
              let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
              if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
                gpSiteNewInfoViewsViews.forEach(item => {
                  if (item.cid == 201) {
                    //学术动态
                    _this.academicList.push(item);
                  }
                  if (item.cid == 202) {
                    //精彩讲座
                    _this.lectureList.push(item);
                  }
                  if (item.cid == 204) {
                    //会一直播
                    _this.meetdirectList.push(item);
                  }
                });
              }
            }
          });
      }
    },
    /* 新闻的点击事件 */
    clkNews (info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 40,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'home/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/home/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    /* 更多 */
    onMore (cid, conetntitle) {
      this.$router.push({
        path: '/home/Inforlist',
        query: {
          pid: 40,
          title: conetntitle,
          cid: cid
        }
      });
    },
    /*全国全科会议及培训*/
    getTrainMeetingList () {
      let _this = this;
      this.httphelper
        .post('/api/MeetingApi/GetMeetingList', {
          mtgType: 0
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.trainmeetinglist = res.data.data.startlist;
            _this.trainmeetinglist = _this.trainmeetinglist.concat(res.data.data.endlist);
          }
        });
    },
    changeTimeSrc (ind, url) {
      var times = this.$refs.time.childNodes;
      for (var i = 0; i < times.length; i++) {
        if (i == ind) {
          //   var imgurl = times[i].firstChild.firstChild.src
          times[i].firstChild.firstChild.src = url;
          //   imgurl = imgurl.substring(0, imgurl.length - 21) + url
        }
      }
    }
  }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    background: #005660;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    /* border-radius: 20px 0px 0px 0px; */
    border-radius: 10px;
}

.bannerright {
    width: 299px;
    height: 380px;
    /* box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15); */
    border-radius: 0px 0px 20px 0px;
}
.main {
    padding: 50px 0;
}
.sign {
    width: 67px;
    padding: 0 10px;
    height: 24px;
    background: #e71518;
    border-radius: 12px;
    color: #fff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    margin-right: 2px;
}
/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1220px;
}
/* 首页文字轮播 */
.bulletWrite {
    margin-right: 6px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #6c9ca3;
    border-radius: 50%;
}

.bulletWriteActive {
    width: 24px;
    height: 10px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
}

.my-bullet-active {
    background: #ff6600;
    opacity: 1;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}

.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.mainCenter {
    margin: 0 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.mainLeft {
    width: 200px;
}

.mainRight {
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.tipsBanner {
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 28px;
    padding-bottom: 23px;
    height: 310px;
    background: url(/image/index/huiyiTips.png) no-repeat;
    background-size: 100% 100%;
}
.tips {
    color: #fff;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
}
.activeLine {
    cursor: pointer;
}
.activeLine:hover {
    color: #0b8485;
}
.activelecture {
    cursor: pointer;
}
.swiper-slide {
    text-align: left;
}
.signDis {
    background: #c4c4c4;
}
.setShow {
    display: none;
}
.controlShow:hover .setShow {
    display: flex;
}
.controlShow:hover .disShow {
    display: none;
}
.scrollSet {
    height: 220px;
    overflow-y: auto;
    position: relative;
}
.scrollSet .timexian {
    width: 1px;
    background-color: #eee;
    position: absolute;
    top: 0;
    left: 5px;
}
.scrollSet::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}
/* 滚动槽 */
.scrollSet::-webkit-scrollbar-track {
    border-radius: 10px;
}
/* 滚动条滑块 */
.scrollSet::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}
.scrollSet::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
.scrollSet .timelistbox {
    display: flex;
}
.timeleft {
    width: 19px;
}
.timeleft img {
    width: 10px;
    height: 10px;
    position: relative;
    z-index: 999;
}
.meetinglist {
    width: 275px;
    height: 43px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}
.titlesytle {
    text-align: center;
    width: 288px;
    height: 17px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}

.titlesytlezhibo {
    width: 300px;
    height: 37px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}
</style>
